import api from './api';
import { normalizeItemCalories } from '../utils/calories';

const resource = 'Item/';

export const list = async (productid) => {
  return await api.get(resource + 'List?PageSize=1000&productid=' + productid);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', normalizeItemCalories(body));
};

export const duplicate = async (id) => {
  return await api.post(resource + 'Duplicate?id=' + id);
};

export const reorder = async (body) => {
  return await api.post(resource + 'Reorder', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

const itemApi = { list, getById, upsert, duplicate, deleteById, reorder };

export default itemApi;
